"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateDetector = void 0;
class DuplicateDetector {
    values = new Set();
    queue = [];
    maxItemCount;
    constructor(maxItemCount) {
        this.maxItemCount = maxItemCount;
    }
    add(value) {
        this.values.add(value);
        this.queue.push(value);
        if (this.queue.length > this.maxItemCount) {
            const removed = this.queue.shift();
            this.values.delete(removed);
        }
    }
    isMostLikelyDuplicate(value) {
        return this.values.has(value);
    }
    size() {
        return this.values.size;
    }
    clear() {
        this.values.clear();
        this.queue = [];
    }
}
exports.DuplicateDetector = DuplicateDetector;
//# sourceMappingURL=DuplicateDetector.js.map